import type { BookingState, BookingAction } from './types'

export const initialState: BookingState = {
  currentStep: 'modality',
  selectedModality: null,
  selectedSlotDetails: []
}

export function bookingReducer(state: BookingState, action: BookingAction): BookingState {
  switch (action.type) {
    case 'setCurrentStep':
      return {
        ...state,
        currentStep: action.payload
      }

    case 'setSelectedModality':
      return {
        ...state,
        selectedModality: action.payload,
        // Changing modality invalidates the picked slots/courts
        selectedSlotDetails:
          state.selectedModality === action.payload ? state.selectedSlotDetails : []
      }

    case 'setSelectedSlotDetails':
      return {
        ...state,
        selectedSlotDetails: action.payload
      }

    case 'reset':
      return initialState

    default:
      return state
  }
}
